/**
 * Returns the flag key when an API error is a feature-flag denial
 * (403 with `{ featureDisabled: true, flagKey }`), null otherwise.
 */
export const featureDisabledFlagKey = (e) => {
  const response = e?.response

  return response?.status === 403 && response.data?.featureDisabled ? response.data.flagKey : null
}

export const isFlagEnabled = (value) => value === true || value === "1"

export const normalizeFlagOverride = (value) => {
  if (value === null || value === undefined) return null

  return isFlagEnabled(value)
}
